export default __webpack_public_path__ + "media/images/rabbit_ui_conversation-04d1b34c8294f956f4ef1f807954167e.png";